import { render, staticRenderFns } from "./CategoriesTrainingComponent.vue?vue&type=template&id=6942c34e&scoped=true"
import script from "./CategoriesTrainingComponent.vue?vue&type=script&lang=js"
export * from "./CategoriesTrainingComponent.vue?vue&type=script&lang=js"
import style0 from "./CategoriesTrainingComponent.vue?vue&type=style&index=0&id=6942c34e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6942c34e",
  null
  
)

export default component.exports